import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { DEFAULT_TIME_ZONE } from '../../../common/resources/src/global-variables';

dayjs.extend(utc);
dayjs.extend(timezone); // dependent on utc plugin

export class MonthlyOfferUtil {
  static getFormattedCurrentMonth() {
    const currentMonth = dayjs().tz(DEFAULT_TIME_ZONE).month() + 1;
    return this.getFormattedMonth(currentMonth);
  }

  static getFormattedMonth(month: number) {
    switch (month) {
      case 1:
        return 'Januar';
      case 2:
        return 'Februar';
      case 3:
        return 'März';
      case 4:
        return 'April';
      case 5:
        return 'Mai';
      case 6:
        return 'Juni';
      case 7:
        return 'Juli';
      case 8:
        return 'August';
      case 9:
        return 'September';
      case 10:
        return 'Oktober';
      case 11:
        return 'November';
      case 12:
        return 'Dezember';
      default:
        return 'Unbekannt';
    }
  }
}
